import React from 'react';
import Subject from "./Subject";

const CategoryCard = ({ bgImage, letter, title, features }) => {
    return (
        <div className="relative h-[400px]  text-white rounded-xl overflow-hidden shadow-md">

            <img
                src={bgImage}
                alt={title}
                className="absolute inset-0 w-full h-full object-cover "
            />

            <div className="relative z-10 p-6 flex flex-col justify-between h-full">

                <div>
                    <h1 className="text-6xl font-serif">{letter}</h1>
                    <h2 className="text-2xl font-bold">
                        for <span className="text-white underline underline-offset-4">{title}</span>
                    </h2>
                </div>


                <div className="grid grid-cols-2 gap-2 mt-4 text-sm">
                    {features.map((item, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                            <span className="text-lg">{item.icon}</span>
                            <span>{item.title}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};


const CategoriesGrid = () => {
    const categories = [
        {
            letter: "A",
            title: "AdTech",
            bgImage: "/bg-ad.jpg",
            features: [
                { icon: "📡", title: "Programmatic development" },
                { icon: "📊", title: "Unified performance analytics" },
                { icon: "🖥️", title: "Custom converged TV solutions" },
                { icon: "💻", title: "Self-service sales platforms" },
                { icon: "📦", title: "Inventory management" },
            ],
        },
        {
            letter: "A",
            title: "AI",
            bgImage: "/bg-ai-.jpg",
            features: [
                { icon: "👁️", title: "Computer vision services" },
                { icon: "🤖", title: "Chatbot development" },
                { icon: "🧠", title: "Natural language processing" },
            ],
        },
        {
            letter: "S",
            title: "Sports",
            bgImage: "/sport.jpg",
            features: [
                { icon: "📺", title: "Live sports events streaming" },
                { icon: "🎯", title: "Fan engagement solutions" },
                { icon: "🏋️", title: "Gym management systems" },
                { icon: "🎮", title: "Fantasy sports experience" },
                { icon: "🏅", title: "Training apps" },
                { icon: "💰", title: "Sports content monetization" },
            ],
        },
        {
            letter: "V",
            title: "Video Streaming",
            bgImage: "/bg3.jpg",
            features: [
                { icon: "📱", title: "OTT apps" },
                { icon: "📡", title: "Connected TV advertising" },
                { icon: "📺", title: "VoD and live streaming" },
                { icon: "🛠️", title: "MAM/workflow orchestration" },
                { icon: "🔌", title: "Video services integration" },
            ],
        },
    ];

    return (
        <div>
            <Subject
                title='Domains — areas where our software development prowess excels'
                description='Our specialty areas are laid out in an easy-to-follow ABC order, so you won’t get turned around.'
            />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">

                {categories.map((cat, idx) => (
                    <CategoryCard key={idx} {...cat} />
                ))}
            </div>
        </div>
    );
};

export default CategoriesGrid;
